import React from "react";
import { Keyboard } from "../../control";
import DialogContent from "./DialogContent";
import DialogButtons from "./DialogButtons";

// --- 展示型元件 (View) ---
// 職責：組合子元件，構建整體佈局和外觀
const SubmitDialogView = ({
  id,
  dialogRef,
  theme,
  submitStatus,
  totalProgress,
  uploadStatus,
  handleSubmit,
  t,
}) => {
  const getDialogDimensions = () => {
    if (submitStatus === 4) {
      return { height: "h-[252px]", width: "w-[100vw] md:w-[70vw] lg:w-[484px] xl:w-[484px]" };
    }
    return { height: "h-auto", width: "w-[100vw] md:w-[70vw] lg:w-[50vw] xl:w-[40vw]" };
  };

  const dialogDimensions = getDialogDimensions();

  return (
    <dialog ref={dialogRef} id={id} className="bg-transparent font-sans antialiased">
      <Keyboard options={[]} keyEnter={handleSubmit} keyEsc={handleSubmit} selected={0} />
      <div id={`${id}-overlay`} className={`fixed inset-0 bg-${theme} bg-opacity-80`} />
      <div className="w-full h-full bg-transparent relative flex justify-center items-center">
        <div className={`relative rounded-md ${dialogDimensions.width} ${dialogDimensions.height} bg-${theme}-dialog flex flex-col border-[1px] border-${theme}-checkbox-disabled`}>
          <div className="w-full h-full flex flex-col">
            <div className={`px-6 py-6 text-${theme}-normal w-full h-full flex flex-col justify-between`}>
              <DialogContent submitStatus={submitStatus} totalProgress={totalProgress} t={t} />
              <div className="flex flex-col md:flex-row w-full mt-10 md:space-x-5 space-y-4 md:space-y-0 justify-end items-center mb-3">
                <DialogButtons submitStatus={submitStatus} uploadStatus={uploadStatus} theme={theme} handleSubmit={handleSubmit} t={t} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </dialog>
  );
};

export default SubmitDialogView;
